import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { fetchJSON, apiRootEndpoint } from '../../helpers';
import {
    GET_PARTNERS, 
    SUBMIT_PARTNER_FORM,
    DELETE_PARTNER
} from '../../constants/actionTypes';


import {
    getAllPartnersSuccess,
    getAllPartnersFailed,

    submitPartnerFormSuccess,
    submitPartnerFormFailed,

    deletePartnerSuccess,
    deletePartnerFailed,
} from './actions';

const apiUrl = `${apiRootEndpoint}/api/v1/portal/partners`;

function* getAllPartners({ payload: { offset, limit } }) {
    const options = {
        method: 'GET',
    };

    try {
        const url = `${apiUrl}?offset=${offset}&limit=${limit}`;
        const {total, data} = yield call(fetchJSON, url, options);
        yield put(getAllPartnersSuccess({total, data}));
    } catch (error) {
        let message;
        switch (error.status) {
            case 500: message = 'Internal Server Error'; break;
            default: message = error;
        }
        yield put(getAllPartnersFailed(message));
    }
}

function* submitPartner({ payload: partner }) {
    const options = {
        body: JSON.stringify(partner),
        method: partner.id ? 'PUT' :  'POST',
        headers: { 'Content-Type': 'application/json' }
    };

    try {
        let url = `${apiUrl}`;
        if(partner.id) {
            url = `${apiUrl}/${partner.id}`;
        }
        const response = yield call(fetchJSON, url, options);
        if(response.status === 'OK') {
            yield put(submitPartnerFormSuccess(response.data));
        }
        else {
            yield put(submitPartnerFormFailed(response.message));
        }
    } catch (error) {
        let message;
        switch (error.status) {
            case 500: message = 'Internal Server Error'; break;
            default: message = error;
        }
        yield put(submitPartnerFormFailed(message));
    }
}

function* deletePartner({ payload: id }) {
    const options = {
        method: 'DELETE',
    };
    try {
        const url = `${apiUrl}/${id}`;
        const response = yield call(fetchJSON, url, options);
        if(response.status === 'OK') {
            yield put(deletePartnerSuccess(id));
        }
        else {
            yield put(deletePartnerFailed(response.message));
        }
    } catch (error) {
        let message;
        switch (error.status) {
            case 500: message = 'Internal Server Error'; break;
            default: message = error;
        }
        yield put(deletePartnerFailed(message));
    }
}


export function* watchGetAllPartners() {
    yield takeEvery(GET_PARTNERS, getAllPartners);
}
export function* watchSubmitPartnerForm() {
    yield takeEvery(SUBMIT_PARTNER_FORM, submitPartner);
}
export function* watchDeletePartner() {
    yield takeEvery(DELETE_PARTNER, deletePartner);
}

function* serviceSaga() {
    yield all([
        fork(watchGetAllPartners),
        fork(watchSubmitPartnerForm),
        fork(watchDeletePartner),
    ]);
}

export default serviceSaga;